import { render, staticRenderFns } from "./keySetup.vue?vue&type=template&id=70d55b3a&scoped=true&"
import script from "./keySetup.vue?vue&type=script&lang=js&"
export * from "./keySetup.vue?vue&type=script&lang=js&"
import style0 from "./keySetup.vue?vue&type=style&index=0&id=70d55b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d55b3a",
  null
  
)

export default component.exports